import { useEffect, useState } from "react";
import { useLogs } from "../contexts/LogsContext"
import Log from "./Log";

const LogsOverlay = () => {

  const logs = useLogs();

  const [logsList, setLogsList] = useState([]);

  useEffect(() => {
    if (logs && logs.logs) {
      setLogsList(logs.logs);
    }
  }, [logs.logs])

  return (
    <div className="absolute bottom-0 ml-2 mb-2 mr-0 w-auto z-10 opacity-80 pointer-events-none">
      {logsList?.map((log, idx) => {
        return <Log key={idx} log={log} overlay={true}/>
      })}
    </div>
  )
}

export default LogsOverlay;